import React from "react";
import {
    TableCell,
    Theme,
    createStyles,
    StandardProps,
    withStyles
} from "@material-ui/core";
import classNames from "classnames";
import { TableCellProps, TableCellClassKey } from "@material-ui/core/TableCell";
import { StylesType, StyleClassKey } from "js/react/typescript";

const styles = (theme: Theme) =>
    createStyles({
        tableHead: {
            "&$root": {
                color: theme.palette.grey["600"],
                backgroundColor: theme.palette.grey["200"]
            }
        },
        root: {
            color: theme.palette.grey["600"],
            border: "none"
        },
        headerBackground: {
            backgroundColor: theme.palette.grey["600"]
        },
        head: {
            fontSize: theme.typography.fontSize,
            textAlign: "center",
            whiteSpace: "nowrap"
        },
        fullWidth: {
            width: "100%"
        },
        bold: {
            fontWeight: "bold"
        }
    });

export type AppTableCellClassKey =
    | StyleClassKey<typeof styles>
    | TableCellClassKey;

export interface AppTableCellProps
    extends StandardProps<TableCellProps, AppTableCellClassKey> {
    fullWidth?: boolean;
    bold?: boolean;
}

const decorator = withStyles(styles as StylesType<AppTableCellClassKey>);

function Component({
    fullWidth,
    bold,
    classes,
    className,
    ...rest
}: AppTableCellProps) {
    const {
        bold: boldClass,
        fullWidth: fullWidthClass,
        headerBackground,
        tableHead,
        ...restClasses
    } = classes;
    return (
        <TableCell
            className={classNames(className, {
                [boldClass]: bold,
                [tableHead]: rest.variant === "head",
                [headerBackground]: rest.variant === "head",
                [fullWidthClass]: fullWidth
            })}
            {...rest}
            classes={restClasses}
        />
    );
}

Component.defaultProps = {
    fullWidth: false,
    bold: false
} as AppTableCellProps;
Component.displayName = "AppTableCell";

export const AppTableCell = decorator(Component);
export default AppTableCell;
